import { FC } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from '@/store';
import { useDispatch } from 'react-redux';
import { userServices } from '@/services';

type propsType = {
    refreshPage: () => void;
};

export const UserLogoutAll: FC<propsType> = ({ refreshPage }) => {
    const dispatch = useDispatch();

    const logoutAll = async (): Promise<void> => {
        dispatch(showLoadingModalReducer());
        const response = await userServices.LogoutAll();
        dispatch(hideLoadingModalReducer());
        dispatch(setAlertResponse({ response }));
        refreshPage();
    }

    return (
        <button className={'btn btn-general-blue fw-bold py-2 my-2'}
            onClick={() => {
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'confirm',
                    title: "¿Cerrar sesiones?",
                    message: "Esta opción cerrará todas las sesiones en todos los dispositivos en que se haya ingresado excepto en este",
                    execution: logoutAll
                }));
            }}
        >
            CERRAR SESIÓN EN TODOS LOS DISPOSITIVOS
        </button>
    );
}
